import { render, staticRenderFns } from "./DiscountActionModal.vue?vue&type=template&id=37e43f56&"
import script from "./DiscountActionModal.vue?vue&type=script&lang=js&"
export * from "./DiscountActionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports